import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterPersonalTrainerPage() {
  return <ClusterPageTemplate clusterName="Personal Trainer" sectorName="Coaches & Consultants" sectorSlug="coaches-consultants" heroTitle="Website laten maken voor een personal trainer" heroDescription="Een krachtige, persoonlijke website voor jouw PT-business. Wij bouwen websites die jouw expertise tonen en zorgen voor een constante stroom aan nieuwe intakes." websiteOnderdelen={[{
    icon: 'UsersIcon',
    title: 'Over de trainer',
    description: 'Jouw verhaal, visie op voeding en training, en je certificeringen. Mensen kiezen voor jóu.'
  }, {
    icon: 'StarIcon',
    title: 'Transformaties',
    description: "Overtuigend bewijs: voor-en-na foto's en succesverhalen van cliënten die hun doelen hebben behaald."
  }, {
    icon: 'BriefcaseIcon',
    title: 'Pakketten & Trajecten',
    description: 'Duidelijke uitleg over 1-op-1 training, small group, online coaching en voedingsadvies.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Gratis intake',
    description: 'Een laagdrempelige pagina om direct een kennismaking of proeftraining in te plannen.'
  }]} functionaliteiten={[{
    icon: 'CalendarCheckIcon',
    title: 'Afspraakplanner',
    description: 'Laat geïnteresseerden direct een moment prikken in jouw agenda (via bijv. Calendly).'
  }, {
    icon: 'FileTextIcon',
    title: 'Uitgebreid intakeformulier',
    description: 'Verzamel vooraf al informatie over doelen, blessures en sportervaring.'
  }, {
    icon: 'ShoppingCartIcon',
    title: 'Online betalen',
    description: 'Mogelijkheid om direct online pakketten af te rekenen via iDEAL of automatische incasso.'
  }]} siblingClusters={[{
    name: 'Coaching',
    slug: 'coaching'
  }, {
    name: 'Consultant',
    slug: 'consultant'
  }, {
    name: 'Sportschool',
    slug: 'sportschool'
  }]} faqs={[{
    q: 'Kan ik online coaching pakketten verkopen via de site?',
    a: "Ja, we kunnen een webshop-module of betaallink (zoals Plug&Pay) toevoegen zodat cliënten direct online programma's kunnen aanschaffen."
  }, {
    q: 'Hoe zorg ik dat ik lokaal gevonden word?',
    a: "We optimaliseren de website voor zoektermen als 'personal trainer [jouw stad]' en helpen je met het inrichten van je Google Bedrijfsprofiel."
  }, {
    q: 'Wat kost een website voor een personal trainer?',
    a: 'Een professionele PT-website start vanaf €1.500. Wil je ook een afgeschermd ledengedeelte of uitgebreide e-commerce, dan maken we een offerte op maat.'
  }, {
    q: "Kan ik zelf transformatie-foto's toevoegen?",
    a: "Absoluut. We bouwen een speciale portfoliomodule waarmee je heel eenvoudig zelf nieuwe succesverhalen en voor-en-na foto's kunt uploaden."
  }]} data-id="element-1087" />;
}